import { alpha, Box, Typography } from "@mui/material";
import { ROLL_COLORS } from "./RollColors";

export const UnassignedRollBox = ({
	rollName,
	badgeRef,
	color,
}: {
	rollName: string;
	badgeRef?: React.RefObject<HTMLDivElement | null>;
	color?: (typeof ROLL_COLORS)[0];
}) => (
	<Box
		ref={badgeRef}
		sx={{
			px: 1.5,
			py: 0.75,
			backgroundColor: color?.bg || alpha("#3b82f6", 0.08),
			border: `2px solid ${color?.border || alpha("#3b82f6", 0.4)}`,
			borderRadius: 1.5,
			display: "inline-flex",
			alignItems: "center",
			height: "fit-content",
			transition: "all 0.2s ease",
			"&:hover": {
				transform: "scale(1.02)",
				boxShadow: `0 2px 8px ${alpha(color?.border || "#3b82f6", 0.25)}`,
			},
		}}
	>
		<Typography
			variant="body2"
			fontWeight={700}
			sx={{
				fontSize: "0.8rem",
				color: color?.text || "#2563eb",
				fontFamily: "monospace",
			}}
		>
			{rollName}
		</Typography>
	</Box>
);
